import { render, staticRenderFns } from "./richtextInput.vue?vue&type=template&id=4ee00936"
import script from "./richtextInput.vue?vue&type=script&lang=js"
export * from "./richtextInput.vue?vue&type=script&lang=js"
import style0 from "@wangeditor/editor/dist/css/style.css?vue&type=style&index=0&lang=css&external"
import style1 from "./richtextInput.vue?vue&type=style&index=1&id=4ee00936&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/data/workspace/KCC_AUDIT_PROD_Frontend/node_modules/vue-loader/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ee00936')) {
      api.createRecord('4ee00936', component.options)
    } else {
      api.reload('4ee00936', component.options)
    }
    module.hot.accept("./richtextInput.vue?vue&type=template&id=4ee00936", function () {
      api.rerender('4ee00936', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/client-view/exchange/ITA/modules/richtextInput.vue"
export default component.exports